
























import { Component, Watch } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

import IndexMixin from '$utils/mixins/index'

import FireBar from './fire-bar.vue'
import RedPacketBags from './red-packet-bags.vue'
import PrizeDialog from './prize-dialog.vue'
import { withdrawCash } from '$services/free-order'
import 'swiper/css/swiper.css'

const actModule = namespace('freeOrder')

@Component({
  name: 'red-packet',
  components: {
    Swiper,
    SwiperSlide,
    FireBar,
    RedPacketBags,
    PrizeDialog
  },
  directives: {
    swiper: directive
  }
})
export default class RedPacket extends IndexMixin {
  @State(state => state.common.loginState) isLogin!: boolean
  @actModule.Getter actEnd!: any
  @actModule.Getter usableIntegral!: any
  @actModule.Getter awardPondList!: any
  @actModule.State prizeList!: any
  get swiper() {
    return (this.$refs.mySwiper as any).$swiper
  }
  @Watch('prizeList')
  onPrizeListChange(prizeList: any[]) {
    if (prizeList) {
      this.dataProcess()
    }
  }
  get fireValue() {
    return this.usableIntegral
  }
  swiperOptions = {
    slidesPerView: 1.6,
    spaceBetween: -30,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: () => {
        if (this.swiper) {
          this.changeIndex(this.swiper.activeIndex)
        }
      }
    },
  }
  activeIndex = 0
  data: any = [
    {
      level: 1,
      status: 3, // 1-已打开，2-已达成，3-即将达成， 4-锁定（默认值）
      value: '',
      minValue: 1,
      maxValue: 8,
      startFireValue: 0,
      fireValue: 2000,
      showBubble: false,
      showValue: '2000',
      prizeId: '',
      grantStatus: ''
    },
    {
      level: 2,
      status: 4,
      value: '',
      minValue: 2,
      maxValue: 10,
      startFireValue: 2000,
      fireValue: 10000,
      showBubble: false,
      showValue: '1w',
      prizeId: '',
      grantStatus: ''
    },
    {
      level: 3,
      status: 4,
      value: '',
      minValue: 3,
      maxValue: 18,
      startFireValue: 10000,
      fireValue: 30000,
      showBubble: false,
      showValue: '3w',
      prizeId: '',
      grantStatus: ''
    },
    {
      level: 4,
      status: 4,
      value: '',
      minValue: 6,
      maxValue: 28,
      startFireValue: 30000,
      fireValue: 70000,
      showBubble: false,
      showValue: '7w',
      prizeId: '',
      grantStatus: ''
    },
    {
      level: 5,
      status: 4,
      value: '',
      minValue: 8,
      maxValue: 58,
      startFireValue: 70000,
      fireValue: 130000,
      showBubble: false,
      showValue: '13w',
      prizeId: '',
      grantStatus: ''
    },
    {
      level: 6,
      status: 4,
      value: '',
      minValue: 66,
      maxValue: 1212,
      startFireValue: 130000,
      fireValue: 300000,
      showBubble: true,
      showValue: '30w',
      prizeId: '',
      grantStatus: ''
    }
  ]
  toastShow = false
  clickFlag = true
  showPrizeDialog = false
  prizeItem: any = ''
  showBubbleIndex = -1
  mounted() {
    // this.swiper.slideTo(this.activeIndex, 1000, false)
  }
  changeIndex(activeIndex: number) {
    this.activeIndex = activeIndex
    this.$Collect.trackView(`2020双12火力红包页面_LV${activeIndex + 1}大红包_浏览`)
  }
  fireBarClick(index: number) {
    this.swiper.slideTo(index, 1000, false)
    this.$Collect.trackEvent(`2020双12火力红包页面_LV${index + 1}小红包_点击`)
  }
  navigationTouchEnd(type: string) {
    if (type === 'next') {
      this.$Collect.trackEvent('2020双12火力红包页面_大红包右滑按钮_点击')
    } else {
      this.$Collect.trackEvent('2020双12火力红包页面_大红包左滑按钮_点击')
    }
  }
  async dataProcess() {
    const list = this.data
    const prizeListFuse: any[] = await this.prizeListFuse()
    this.data.forEach((el: any, index:number) => {
      const prize = prizeListFuse[index] || ''
      // 奖品状态（1: 未领取 ,2：未激活, 3：未使用, 4：冻结, 5:使用中, 6:已使用，7：已过期 8:已作废）
      if (prize.grantStatus) {
        list[index].grantStatus = prize.grantStatus
        list[index].prizeId = prize.prizeId
        if (prize.grantStatus === 6) {
          list[index].status = 1
          list[index].value = this.getPrizeValue(prize.dictPrizeAttributeRespDTOS)
        } else {
          list[index].status = 2
        }
      } else if (this.fireValue >= list[index].fireValue && !prize.grantStatus) {
        list[index].notStock = true
      } else if (this.fireValue >= list[index].startFireValue && this.fireValue < list[index].fireValue) {
        list[index].status = 3
        if (index < 5) {
          this.showBubbleIndex = index + 1
        }
      } else {
        list[index].status = 4
      }
      list[index].showBubble = false
    })
    if (list[this.showBubbleIndex]) {
      list[this.showBubbleIndex].showBubble = true
    }
    this.data = list
    this.listFinder(list)
  }
  prizeListFuse() {
    const { awardPondList, prizeList } = this
    const list = awardPondList.map((el: any) => {
      const { awardRespBOS } = el
      for (let i = 0; i < awardRespBOS.length; i++) {
        const prize = prizeList.filter((n: any) => n.prizeCode === awardRespBOS[i].awardCode)[0]
        if (prize) {
          el.grantStatus = prize.grantStatus
          el.dictPrizeAttributeRespDTOS = prize.dictPrizeAttributeRespDTOS
          el.prizeId = prize.prizeId
        }
      }
      return el
    })
    return list
  }
  listFinder(list: any[]) {
    const reach = list.filter(el => el.status === 2)
    const doing = list.filter(el => el.status === 3)[0]
    if (reach.length > 0) {
      this.activeIndex = reach[reach.length - 1].level - 1
    } else if (doing) {
      this.activeIndex = doing.level - 1
    }
    this.swiper.slideTo(this.activeIndex, 1000, false)
  }
  getPrizeValue(dtos: any[]) {
    const valueOb: any = dtos.filter((el: any) => el.prizeAttributeCode === 'xj_value')[0]
    const { fieldValue } = valueOb.prizeAttributeFieldValueRespDTOList[0]
    return fieldValue
  }
  async gainClickHandler(item: any) {
    this.$Collect.trackEvent(`2020双12火力红包页面_LV${item.level}大红包_开_点击`)
    if (!this.clickFlag) {
      return
    }
    if (this.actEnd) {
      this.$ssvue.toast.show('活动已结束，去看看免单大奖是否砸中你！')
      return
    }

    const btnFlag = await this.btnCommonHandle()
    if (!btnFlag) {
      return
    }

    if (item.notStock) {
      this.$ssvue.toast.show('库存不足')
      return
    }
    if (item.status > 2) {
      this.showToast()
    } else {
      !this.toastShow && this.gainRedPacket(item)
    }
  }
  showToast() {
    this.toastShow = true
    setTimeout(() => {
      this.toastShow = false
      this.$store.commit('freeOrder/updateBreathe', true)
    }, 1500)
  }
  gainRedPacket(item: any) {
    console.log(item)
    if (!item.prizeId) {
      this.showToast()
      return
    }
    withdrawCash({
      prizeId: item.prizeId
    })
      .then(async(res: any) => {
        if (res.result) {
          await this.$store.dispatch('freeOrder/queryPrizePage')
          this.prizeItem = this.data[item.level - 1]
          this.showPrizeDialog = true
          this.$Collect.trackView('2020双12红包领取弹窗_浏览', {}, {
            page_name: '红包领取弹窗'
          })
        } else {
          this.$ssvue.toast.show('服务器出错啦~')
        }
      })
  }
}
